import { Component, ElementRef, Renderer2 } from '@angular/core'
import { MbPaymentOptionsWrapperBase } from '../mb-payment-methods/mb-payment-options-wrapper-base'
import { ActiveCartService } from '@spartacus/cart/base/core'

@Component({
  selector: 'mb-payment-methods-wrapper',
  templateUrl: './mb-payment-methods-wrapper.component.html',
})
export class MbPaymentMethodsWrapperComponent extends MbPaymentOptionsWrapperBase {
  constructor (protected activeCartService: ActiveCartService,
               protected elemRef: ElementRef,
               protected renderer: Renderer2) {
    super(activeCartService, elemRef, renderer)
  }
}
